module.exports = __webpack_public_path__ + "media/images/emblems/Altikon-blazon-47175cea126f1f382c56300255721238.svg";